export default __webpack_public_path__ + "static/clients03-fd9d0001b24cc8bfa32d35c22f6f33c0.svg";